import { defineStore } from "pinia";
import { apiCall } from "../../utils/api";

export const useCardCategoryStore = defineStore("cardCategory", {
  state: () => ({
    categories: [],
  }),
  getters: {
    categoryObj: (state) => {
      const rtn = {};
      state.categories.forEach((item) => {
        rtn[item.id] = item.name;
      });
      return rtn;
    },
    packRarities: (state) => {
      return (ids) => {
        let rtn = [];
        for (let id of ids) {
          for (let category of state.categories) {
            if (id === category.id) {
              rtn = rtn.concat(Object.keys(category.packRarityParams));
            }
          }
        }
        return [...new Set(rtn)];
      };
    },
    cardRarities: (state) => {
      return (ids) => {
        let rtn = [];
        for (let id of ids) {
          for (let category of state.categories) {
            if (id === category.id) {
              rtn = rtn.concat(Object.keys(category.cardRarityParams));
              break;
            }
          }
        }
        return [...new Set(rtn)];
      };
    },
  },
  actions: {
    async getAll(force = false) {
      if (force || this.categories.length === 0) {
        const response = await apiCall("card.getCategories", {});
        if (!response) {
          return false;
        }
        this.categories = response;
      }

      return true;
    },
    async add(params = {}) {
      const response = await apiCall("card.addCategory", params);
      if (!response) {
        return false;
      }
      await this.getAll(true);
      return true;
    },
    async edit(id, params = {}) {
      params.id = id;
      const response = await apiCall("card.modifyCategory", params);
      if (!response) {
        return false;
      }
      await this.getAll(true);
      return true;
    },
  },
});
